import axios from 'axios'

// const baseUrl = import.meta.env.VITE_API_SERVER || import.meta.env.BASE_URL
const baseUrl = `${window.location.origin}/api`
console.debug(`API: ${baseUrl}`)

const req = axios.create({ withCredentials: true, baseURL: baseUrl })

const api = {
  connectionStatus: null,

  connectionCallbacks: [],

  updateConnectionStatus(newStatus /*, response, error*/) {
    if (this.connectionStatus != newStatus) {
      this.connectionStatus = newStatus
      this.connectionCallbacks.forEach((fn) => fn(newStatus))
    }
  },

  vendors: {
    async get(slug) {
      console.log(`API: vendors.get(${slug})`)
      return req.get(`/vendors/${slug}`).then((r) => r.data)
    },

    async listEvents(slug) {
      console.log(`API: vendors.listEvents(${slug})`)
      return req.get(`/vendors/${slug}/events`).then((response) => response.data)
    },
  },

  catalog: {
    async getEvent(eventSlug, previewToken = null) {
      console.log(`API: catalog.getEvent(${eventSlug}, preview=${previewToken ? 'yes' : 'no'})`)
      const params = previewToken ? { preview: previewToken } : {}
      return req.get(`/catalog/${eventSlug}`, { params }).then((r) => r.data)
    },

    async listProducts(eventSlug, previewToken = null) {
      console.log(`API: catalog.listProducts(${eventSlug}, preview=${previewToken ? 'yes' : 'no'})`)
      const params = previewToken ? { preview: previewToken } : {}
      return req.get(`/catalog/${eventSlug}/products`, { params }).then((r) => r.data)
    },

    async getProductAvailability(eventSlug, productId, previewToken = null) {
      console.log(`API: catalog.getProductAvailability(${eventSlug}, ${productId})`)
      const params = previewToken ? { preview: previewToken } : {}
      return req.get(`/catalog/${eventSlug}/products/${productId}/availability`, { params }).then((r) => r.data)
    },
  },

  orders: {
    async create(productKey, rentalOptionId, dates, quantity = 1) {
      console.log(`API: orders.create()`)
      return req.post('/orders', {
        productKey,
        rentalOptionId,
        dates,
        quantity,
      }).then((r) => r.data)
    },

    async get(token) {
      console.log(`API: orders.get(${token})`)
      return req.get(`/orders/${token}`).then((r) => r.data)
    },

    async update(token, { customerName, customerEmail, customerPhone }) {
      console.log(`API: orders.update(${token})`)
      return req.patch(`/orders/${token}`, {
        customerName,
        customerEmail,
        customerPhone,
      }).then((r) => r.data)
    },

    async cancel(token) {
      console.log(`API: orders.cancel(${token})`)
      return req.delete(`/orders/${token}`).then((r) => r.data)
    },

    async createPaymentIntent(token) {
      console.log(`API: orders.createPaymentIntent(${token})`)
      return req.post(`/orders/${token}/payment-intent`).then((r) => r.data)
    },

    async confirmPayment(token, payload = {}) {
      console.log(`API: orders.confirmPayment(${token})`)
      return req.post(`/orders/${token}/confirm`, payload).then((r) => r.data)
    },

    async preview(productKey, rentalOptionId, dates, quantity = 1) {
      console.log(`API: orders.preview()`)
      return req.post('/orders/preview', {
        productKey,
        rentalOptionId,
        dates,
        quantity,
      }).then((r) => r.data)
    },
  },

  ping() {
    return req.get('/utils/ping').then((response) => response.data)
  },
}

const handleApiError = (error) => {
  // Handle network errors (no response received)
  if (!error.response) {
    if (error.request) {
      api.updateConnectionStatus('offline', null, error)
    } else {
      // Log client-side errors (e.g., request config errors)
      console.debug('API Error:', error.message)
    }
    return Promise.reject(error)
  }

  const { status } = error.response

  // Handle 401 Unauthorized - redirect to login
  if (status === 401 && !location.pathname.startsWith('/login')) {
    const { origin, pathname, hash } = window.location
    const route = hash.startsWith('#/') ? hash.slice(2) : hash
    const app = pathname.replace(/^\/+|\/+$/g, '')

    let redirectPath = '/login'
    if (route) redirectPath += `#${route}`
    if (app) redirectPath += `${route ? '&' : '#'}a=${app}`

    window.location.href = `${origin}${redirectPath}`
    return Promise.reject(new Error('Unauthorized - redirecting to login'))
  }

  // For other error responses, reject with the error
  return Promise.reject(error)
}

// Response interceptor
req.interceptors.response.use(
  (response) => {
    api.updateConnectionStatus('online', response)
    return response
  },
  (error) => handleApiError(error)
)

export default api
